import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-progress',
  templateUrl: './progress.component.html',
  styleUrls: ['./progress.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ProgressComponent {
  @Input() value: number;

  @Input() displayLabel?: boolean;
  @Input() weeksProgress = 0;

  /**
   * Calculates negative margin for the label to flow to correct positions at 0%, 50% and 100% and not overflow
   */
  calculateMarginForLabel() {
    return Math.abs(Math.sin((this.value / 100) * (Math.PI / 100) * 100)) * -25;
  }
}
